import gql from 'graphql-tag';

export const MUTATION = gql`
  mutation CreateTsSupportAdminRole($organizationId: ID!, $supportRoles: [SupportRoles]!) {
    createTsSupportAdminRole(organizationId: $organizationId, supportRoles: $supportRoles) {
      scopeId
      organizationId
      type
      scopeType
      userId
    }
  }
`;
